"use client";

import { useSSE } from "@/modules/hooks/realtime/useSSE";

const RealtimeProvider = () => {
  const {} = useSSE();

  return <></>;
};

RealtimeProvider.displayName = "RealtimeProvider";
export default RealtimeProvider;
